import React from 'react'
import {
  Box,
  CircularProgress,
  Skeleton,
  Typography,
  Stack,
  Paper,
} from '@mui/material'

interface LoadingStateProps {
  type?: 'spinner' | 'skeleton' | 'table'
  message?: string
  rows?: number
  columns?: number
  height?: number | string
}

export const LoadingState: React.FC<LoadingStateProps> = ({
  type = 'spinner',
  message = 'Cargando...',
  rows = 5,
  columns = 4,
  height = 400,
}) => {
  if (type === 'skeleton') {
    return (
      <Box sx={{ width: '100%', p: 2 }}>
        <Stack spacing={1}>
          <Skeleton variant="text" height={40} width="30%" />
          <Skeleton variant="rectangular" height={60} />
          <Skeleton variant="text" height={20} width="60%" />
          <Skeleton variant="text" height={20} width="40%" />
          <Skeleton variant="text" height={20} width="80%" />
        </Stack>
      </Box>
    )
  }

  if (type === 'table') {
    return (
      <Paper sx={{ p: 2, height }}>
        <Stack spacing={2}>
          <Skeleton variant="text" height={30} width="25%" />
          <Skeleton variant="rectangular" height={50} />
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <Stack key={rowIndex} direction="row" spacing={2}>
              {Array.from({ length: columns }).map((_, colIndex) => (
                <Skeleton
                  key={colIndex}
                  variant="text"
                  height={20}
                  width={`${Math.floor(Math.random() * 40) + 20}%`}
                />
              ))}
            </Stack>
          ))}
        </Stack>
      </Paper>
    )
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: typeof height === 'number' ? `${height}px` : height,
        gap: 2,
      }}
    >
      <CircularProgress size={48} thickness={4} />
      {message && (
        <Typography variant="body1" color="text.secondary">
          {message}
        </Typography>
      )}
    </Box>
  )
}

export default LoadingState